// Reusable online status indicator dot
const ONLINE_INDICATOR_SIZES = {
  sm: 'w-2 h-2 border-[1.5px]',
  md: 'w-2.5 h-2.5 border-2',
  lg: 'w-3 h-3 border-2',
} as const

interface OnlineIndicatorProps {
  size?: keyof typeof ONLINE_INDICATOR_SIZES
}

export default function OnlineIndicator({ size = 'md' }: OnlineIndicatorProps) {
  return (
    <span
      className={`absolute bottom-0 right-0 bg-green-500 border-white rounded-full ${ONLINE_INDICATOR_SIZES[size]}`}
    />
  )
}
